export default __webpack_public_path__ + "static/media/plans.9928fe8f.svg";